import { useTrackTheme } from '@shared/lib/theme'
import { useObserveMobileMode } from '@shared/model'
import '@styles/global-styles.css'
import '@styles/variables.css'

import styles from '@styles/index.module.css'
import { AppRouter } from './routing'

export const App = () => {
  useTrackTheme()
  useObserveMobileMode()

  return (
    <section className={styles.app}>
      <AppRouter />
    </section>
  )
}
